import React from 'react'
import {
  BlockingLoader,
  Container,
  Image,
  ListContainer,
  TextBody,
  TextCaption,
  TextTitle,
  Css
} from '@pmi/pmi-iqos-ds-react'
import { htmlTranslation } from '@pmi/pmi-iqos-shared-react'

const QrTierCard = ({
  translations,
  qrImage,
  fullName,
  date,
  tierStaticInfo
}) => {
  const { cardPortrait: bgImage, darkMode, type } = tierStaticInfo
  return (
    <Container
      display={Container.displays.flex}
      justifyContent={Container.justifyContentValues.center}>
      <Container position={Container.positions.relative}>
        {bgImage && <Image src={bgImage} height={['128', '160']} />}
        <Container
          position={Container.positions.absolute}
          t="0"
          l="0"
          r="0"
          b="0"
          display={Container.displays.flex}
          flexDirection={Container.flexDirections.column}
          alignItems={Container.alignItemsValues.center}
          justifyContent={Container.justifyContentValues.between}>
          <Container pt={['18', '24']}>
            <Container
              height={['40', '48']}
              width={['40', '48']}
              position={Container.positions.relative}>
              {qrImage && (
                <Container position={Container.positions.absolute} zIndex="2">
                  <Image
                    width={['40', '48']}
                    height={['40', '48']}
                    src={qrImage}
                  />
                </Container>
              )}
              <BlockingLoader loading zIndex="1" />
            </Container>
          </Container>
          <Container pb={['24']} pl={['14', '18']} fullWidth>
            <Container
              display={Container.displays.flex}
              flexDirection={Container.flexDirections.column}>
              <Container pb={['', '4']}>
                <TextCaption
                  darkMode={darkMode}
                  size={TextBody.sizes.s}
                  additionalClasses="q-text-white">
                  {translations.tk_currentStage}
                </TextCaption>
              </Container>
              <Container pb={['', '6']}>
                <Css
                  classname="q-font-bold q-text-9xl q-leading-none q-text-white"
                  darkMode={darkMode}>
                  {htmlTranslation(translations, `tk_${type}`)?.value}
                </Css>
              </Container>
              <TextTitle darkMode={darkMode} heading={TextTitle.headings.h6}>
                {fullName}
              </TextTitle>
              <ListContainer xBetween="2">
                <TextBody
                  darkMode={darkMode}
                  size={TextBody.sizes.m}
                  {...htmlTranslation(translations, 'tk_expirationDate')}
                />
                <TextBody
                  darkMode={darkMode}
                  size={TextBody.sizes.m}
                  value={date}
                />
              </ListContainer>
            </Container>
          </Container>
        </Container>
      </Container>
    </Container>
  )
}

export default QrTierCard
